import React from "react";
import createReactClass from "create-react-class";
import Reflux from "reflux";

import moment from "moment";

import FacetSearchDateRangePicker from "@reactComponents/facetSearch/timeSelector/FacetSearchDateRangePicker";
import Heading from "@reactComponents/lds/typography/Heading";
import { parseDate } from "@reactComponents/facetSearch/timeSelector/timeSelectorHelpers";
import TimeSelectDropdown from "@reactComponents/facetSearch/TimeSelectDropdown";

import { createPathMatcher, getPageFromUrl, parseUrlSegments } from "@javascript/helpers/urlUtilities";

const HIDDEN_STYLES = {
  display: "none",
};

const PAGE_PATTERNS = [
  {
    // avoid returning true for /feeds/ID/edit
    pattern: "/feeds",
    matcher: (url) => {
      const segments = parseUrlSegments(url);
      return (segments[0] === 'feeds' && segments.length === 2) ||  // /feeds/ID, /feeds/ID?params
        createPathMatcher(['feeds', '*', 'display_saved_feed'])(url);  // /feeds/ID/display_saved_feed
    }
  },
  {
    pattern: "/mapping",
    matcher: createPathMatcher(['mapping'])
  },
  {
    pattern: "/facet_search",
    matcher: createPathMatcher(['facet_search'])
  },
  {
    pattern: "/events",
    matcher: createPathMatcher(['company', '*', 'events'])
  },
  {
    pattern: "/sales_assistant",
    matcher: (url) => {
      const terms = [
        "trials",
        "therapies",
        "conditions",
        "medical_technologies",
        "pharma_ingredients"
      ];
      const segments = parseUrlSegments(url);
      return (
        segments.length === 4 &&
        segments[0] === "sales_assistant" &&
        terms.includes(segments[1]) &&
        segments[3] === "feed"
      );
    }
  }
];

const FacetSearchTimeSelector = createReactClass({
  mixins: [
    Reflux.connectFilter(FacetSearchStore, function (data) {
      return {
        timeFrame: data.timeFrame,
      };
    }),
  ],
  getInitialState() {
    return {
      datePickerRef: React.createRef(),
      page: getPageFromUrl(PAGE_PATTERNS, "edit_feed"),
      showRangePicker: false,
      timeSelectRef: React.createRef(),
    };
  },
  componentDidUpdate(prevProps, prevState) {
    const nowSelected = this.state.timeFrame.selected;
    const prevSelected = prevState.timeFrame?.selected;

    // Only care when selected timeframe is custom
    if (nowSelected === "time_custom" && nowSelected !== prevSelected) {
      this.setState({ showRangePicker: true });
    }
  },
  closeRangePicker() {
    this.setState({ showRangePicker: false });
    this.state.timeSelectRef.current.open();
  },
  openRangePicker(open) {
    this.setState({ showRangePicker: true });
    open && this.state.datePickerRef.current.open();
  },
  render() {

    if (this.state.page === "edit_feed") return null;

    const { showRangePicker } = this.state;
    let fromDate = parseDate(this.state.timeFrame?.from);
    let toDate = parseDate(this.state.timeFrame?.to);

    if (!fromDate.isValid()) {
      fromDate = moment().subtract(10, "years");
    }

    if (!toDate.isValid()) {
      toDate = moment();
    }

    const renderRangePicker =
      showRangePicker && this.state.timeFrame.selected === "time_custom";

    // Render both, but hide one using CSS to avoid jitter issues
    return (
      <>
        <Heading
          leadingIcon="calendar"
          size="h3"
        >
          {Zymewire.facet_search_filters.date_range}
        </Heading>
        <div style={renderRangePicker ? {} : HIDDEN_STYLES}>
          <FacetSearchDateRangePicker
            onDismiss={this.closeRangePicker}
            fromDate={fromDate.toDate()}
            toDate={toDate.toDate()}
            dropdownRef={this.state.datePickerRef}
            datePickerVisible={renderRangePicker}
          />
        </div>

        <div style={renderRangePicker ? HIDDEN_STYLES : {}}>
          <TimeSelectDropdown
            onCustomTimeSelect={this.openRangePicker}
            dropdownRef={this.state.timeSelectRef}
          />
        </div>
      </>
    );
  },
});

export default FacetSearchTimeSelector;

window.FacetSearchTimeSelector = FacetSearchTimeSelector;
